<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <data-permission-sidebar :isSidebarActive="addNewPermissionDataSidebar" @getdata="getdata" @closeSidebar="togglePermissionDataSidebar" :data="permissionSidebarData" />
    <all-permission-sidebar :isSidebarActive="addNewPermissionListSidebar" @getdata="getdata" @closeSidebar="togglePermissionListSidebar" :data="permissionSidebarList" />

    
   <div>
   <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Permission</vs-button>

      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    </div>
    <vs-table ref="table" search pagination :max-items="itemsPerPage"  :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <vs-button  type="filled" @click.native="allPermissions">All Permissions</vs-button>
        </div>

        <!-- ITEMS PER PAGE -->

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Role</vs-th>
         <vs-th>Permissions</vs-th>
         <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td><vs-chip color="primary" class="text-white">{{tr.name}}</vs-chip></vs-td>
              <vs-td v-if="tr.permissions.length>0">
                  <span :key="indexx" v-for="(permission, indexx) in tr.permissions">
                  <vs-chip @click="confirmDeleteRecord(tr.id,permission.id)" closable>{{permission.name}}</vs-chip>
                  </span>
              </vs-td>
              <vs-td v-else>
                <p>N/A</p>
              </vs-td>
                  <vs-td>
                    <vs-button size="small" @click.native="editPermissionData(tr)">Add</vs-button>
                  </vs-td>
               <!-- <vs-td class="whitespace-no-wrap">
                  <feather-icon v-if="tr.log.length===0" icon="EditIcon" @click="editData(tr)" svgClasses="h-4 w-4" class="mr-2"/>
                  <feather-icon icon="TrashIcon" @click="confirmDeleteRecord(tr)" svgClasses="h-4 w-4" class="mr-2 "/>
                  <feather-icon icon="CopyIcon" @click="DuplicateTemplate(tr)" svgClasses="h-4 w-4" class="mr-2 "/>
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-4 h-4 hover:text-primary stroke-current"  icon="DownloadIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                <span class="flex items-center"  @click="DownloadPdf(tr)"> Download PDF
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center"  @click="DownloadJPEG(tr)">Download JPEG</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td> -->
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import DataPermissionSidebar from './DataPermissionSidebar.vue'
import AllPermissionSidebar from './AllPermissionSidebar.vue'
import {ALL_ROLE, REMOVE_ROLE_PERMISSION} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  // dirName: process.env.VUE_APP_AWS_DIREC,
  dirName: 'newsletters',
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)
export default {
  components: {
    DataViewSidebar,
    DataPermissionSidebar,
    AllPermissionSidebar
  },
  data () {
    return {
      roles:[],
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      addNewPermissionDataSidebar: false,
      addNewPermissionListSidebar: false,
      sidebarData: {},
      permissionSidebarData:{},
      permissionSidebarList:{},
      role:null,
      activeLoading :false
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.roles
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    getdata () {
      this.get()
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    allPermissions () {
      this.permissionSidebarList = {}
      this.togglePermissionListSidebar(true)
    },
    addNewPermissionData () {
      this.permissionSidebarData = {}
      this.togglePermissionDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    editPermissionData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.permissionSidebarData = data
      this.togglePermissionDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    togglePermissionDataSidebar (val = false) {
      this.addNewPermissionDataSidebar = val
    },
    togglePermissionListSidebar (val = false) {
      this.addNewPermissionListSidebar = val
    },
    confirmDeleteRecord (role_id, permission_id) {
      this.deleteItem = {role_id, permission_id}
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'You are about to permanently delete',
        accept: this.removeRole,
        acceptText: 'Delete'
      })
    },
    removeRole () {
      this.$apollo
        .mutate({
          mutation: REMOVE_ROLE_PERMISSION,
          variables: {
            role_id:  this.deleteItem.role_id,
            permission_id:this.deleteItem.permission_id
          }
        })
        .then(response => {
          this.get()
          if (response.data.removeRolePermission.status === 'Success') {
            this.StatusSuccess(response.data.removeRolePermission.message, response.data.removeRolePermission.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Permission Managment',
        text: status,
        color,
        position: 'top-right'
      })
    },
    loader () {
      this.activeLoading = true
      this.$vs.loading({
        type:'sound'
      })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_ROLE
        })
        .then(response => {
          this.roles = response.data.roles
          this.activeLoading = false
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.loader()
    this.get()
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.role = userRoles[0]['name']
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

